import { operatorApiFetch } from './apiService';

export const inventoryMonitorService = {
  // 列表
  getRecords: async (params) => {
    const response = await operatorApiFetch('inventory_monitors/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await operatorApiFetch('inventory_monitors/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 單一資源
  get: async (id) => {
    const response = await operatorApiFetch(`inventory_monitors/${id}`);
    return response.json();
  },

  // 建立
  create: async (data) => {
    const response = await operatorApiFetch('inventory_monitors', {
      method: 'POST',
      body: JSON.stringify({ inventory_monitor: data })
    });
    return response.json();
  },

  // 更新
  update: async (id, data) => {
    const response = await operatorApiFetch(`inventory_monitors/${id}`, {
      method: 'PUT',
      body: JSON.stringify({ inventory_monitor: data })
    });
    return response.json();
  },

  // 刪除
  delete: async (id) => {
    const response = await operatorApiFetch(`inventory_monitors/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // 批次刪除
  batchDelete: async (ids) => {
    const response = await operatorApiFetch('inventory_monitors/batch_delete', {
      method: 'POST',
      body: JSON.stringify({ ids })
    });
    return response.json();
  }
};
